module.exports = __webpack_public_path__ + "img/edge_restauration_producteur_vin.d2f9a41c.svg";